import { render } from "./Basic.vue?vue&type=template&id=1ada4395"
import script from "./Basic.vue?vue&type=script&lang=ts"
export * from "./Basic.vue?vue&type=script&lang=ts"
script.render = render

export default script